// @ts-check

import { api } from '@/api'

/**
 * Fetches the latest terms.
 */
export const getTermsOfService = async () => api.get('terms')

/**
 * Accepts the terms with the given id.
 * @param {number} termsId
 */
export const acceptTerms = async (termsId) =>
  api.patch(`terms/${termsId}/accept`)
